import { ITicketMast } from "../../models/TicketMast";

export const EmptyTicket: ITicketMast = {
    ticket_ID: undefined,
    department: 0,
    ticket_Subject: "",
    issue: "",
    ticket_Status: "Open"
}